function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
import { iconValid, urlValid } from '../../helpers';
import { Spacer } from '../Spacer/Spacer';
import { StyledButton } from './styles';
const Button = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    theme,
    selectedTheme,
    text,
    textSize,
    noText,
    borderSize,
    color,
    hoverColor,
    textColor,
    buttonType,
    icon,
    iconRight,
    fontFamily,
    url,
    passthrough,
    callback,
    children,
    round,
    pill,
    column,
    padding,
    width,
    height,
    ...rest
  } = props;
  const handleClick = e => {
    const validUrl = urlValid(url);
    if (rest.type === 'submit') e.preventDefault();
    if (passthrough) e.stopPropagation();
    if (validUrl) window.open(validUrl, rest.target || '_blank');
    callback?.();
  };
  const buildContent = () => {
    const validLeft = icon && !iconRight && iconValid(icon);
    const validRight = icon && iconRight && iconValid(icon);
    return /*#__PURE__*/React.createElement(React.Fragment, null, validLeft && /*#__PURE__*/React.createElement("i", {
      className: icon
    }), !noText && validLeft && /*#__PURE__*/React.createElement(Spacer, {
      size: 1,
      across: true
    }), !noText && (text || children || rest.type === 'submit' && 'Submit'), !noText && validRight && /*#__PURE__*/React.createElement(Spacer, {
      size: 1,
      across: true
    }), validRight && /*#__PURE__*/React.createElement("i", {
      className: icon
    }));
  };
  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    ref: ref,
    $theme: theme,
    $selectedTheme: selectedTheme,
    $buttonType: buttonType,
    $textSize: textSize,
    $noText: noText,
    $color: color,
    $hoverColor: hoverColor,
    $textColor: textColor,
    $fontFamily: fontFamily,
    $round: round,
    $pill: pill,
    $column: column,
    $borderSize: borderSize,
    $padding: padding,
    $width: width,
    $height: height,
    onClick: handleClick
  }, rest), buildContent());
});
export { Button };